<div [@routerTransition]>
    <sub-header
        [title]="('CustomerPayments' | localize) + ' ' + ('Details' | localize)"
        [breadcrumbs]="breadcrumbs"
    ></sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="CustomerDisplayProperty">{{ l('Customer') }}</label>
                            <app-search-customer (customerEvent)="getCustomer($event)"
                                                 [customerSelectedItem]="this.customerSelectedItem"></app-search-customer>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="CustomerPayment_ReceiptDate">{{ l('ReceiptDate') }}</label>

                            <abp-datetime-picker #CustomerPayment_ReceiptDate="ngModel"
                                                 [(ngModel)]="customerPayment.receiptDate"
                                                 id="CustomerPayment_ReceiptDate"
                                                 name="CustomerPayment_ReceiptDate"
                                                 [bsConfig]="{ adaptivePosition: true }"></abp-datetime-picker>

                            <validation-messages [formCtrl]="CustomerPayment_ReceiptDate"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group m-form__group">
                            <label for="PaymentTypeName">{{ l('PaymentType') }}</label>
                            <select name="customerPayment.paymentTypeId"
                                    [(ngModel)]="customerPayment.paymentTypeId"
                                    class="form-select">
                                <option value="null">{{ l('SelectAPaymentType') }}</option>

                                <option *ngFor="let item of allPaymentTypes" value="{{ item.id }}">
                                    {{ item.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="CustomerPayment_Reference">{{ l('Reference') }}</label>
                            <input type="text"
                                   #CustomerPayment_Reference="ngModel"
                                   id="CustomerPayment_Reference"
                                   class="form-control"
                                   [(ngModel)]="customerPayment.reference"
                                   name="Reference" />
                            <validation-messages [formCtrl]="CustomerPayment_Reference"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="CustomerPayment_TotalBalance">{{ l('TotalBalance') }}</label>
                            <input type="number"
                                   id="CustomerPayment_TotalBalance"
                                   class="form-control text-end"
                                   [(ngModel)]="totalBalance"
                                   name="TotalBalance"
                                   disabled="disabled" />
                        </div>
                    </div>
                    <!-- <div class="col-md-2">
                        <div class="form-group pt-6">
                            <label for="CustomerPayment_Amount">&nbsp;&nbsp;&nbsp;</label>
                            <input type="checkbox"
                                   #CustomerPayment_IsPDCPayment="ngModel"
                                   id="CustomerPayment_IsPDCPayment"
                                   class="form-check-input"
                                   [(ngModel)]="customerPayment.isPDCPayment"
                                   name="IsPDCPayment" />
                            <label class="form-label" for="CustomerPayment_IsPDCPayment"> &nbsp; {{ l('IsPDCPayment') }}</label>
                        </div>
                    </div> -->
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="CustomerPayment_PaymentDiscount">
                                {{ l('Discount') }}
                            </label>
                            <input type="number"
                                   #CustomerPayment_PaymentDiscount="ngModel"
                                   id="CustomerPayment_PaymentDiscount"
                                   class="form-control text-end"
                                   [(ngModel)]="customerPayment.paymentDiscount"
                                   name="PaymentDiscount" (ngModelChange)="calculateTotalValue()" />
                            <validation-messages [formCtrl]="CustomerPayment_PaymentDiscount"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="CustomerPayment_Amount">{{ l('Amount') }}</label>
                            <input type="number"
                                   #CustomerPayment_Amount="ngModel"
                                   id="CustomerPayment_Amount"
                                   class="form-control text-end"
                                   [(ngModel)]="customerPayment.amount"
                                   name="Amount" disabled="disabled" />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="CustomerPayment_Amount">{{ l('AppliedAmount') }}</label>
                            <input type="number"
                                   id="AppliedAmount"
                                   class="form-control text-end"
                                   [(ngModel)]="appliedAmount"
                                   name="Amount" disabled="disabled" />
                        </div>
                    </div>

                    <div class="col-md-8">
                        <div class="form-group">
                            <label for="CustomerPayment_Remarks">{{ l('Remarks') }}</label>
                            <input type="text"
                                   #CustomerPayment_Remarks="ngModel"
                                   id="CustomerPayment_Remarks"
                                   class="form-control"
                                   [(ngModel)]="customerPayment.remarks"
                                   name="Remarks" />
                            <validation-messages [formCtrl]="CustomerPayment_Remarks"></validation-messages>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="CustomerPayment_BalanceAmount">{{ l('BalanceAmount') }}</label>
                            <input type="number"
                                   id="CustomerPayment_BalanceAmount"
                                   class="form-control text-end"
                                   [(ngModel)]="balanceAmount"
                                   name="Amount"
                                   disabled="disabled" />
                        </div>
                    </div>
                </div>
                <div class="row mt-10">
                    <div class="col-md-12">
                        <table class="table table-striped table-bordered col-xs-12">
                            <thead>
                                <tr>
                                    <th>{{ l('#') }}</th>
                                    <th>{{ l('TransactionNo') }}</th>
                                    <th>{{ l('Reference') }}</th>
                                    <th class="text-right">{{ l('TransactionType') }}</th>
                                    <th class="text-right">{{ l('Date') }}</th>
                                    <th class="text-right">{{ l('DueDate') }}</th>
                                    <th class="text-right">{{ l('Amount') }}</th>
                                    <th class="text-right">{{ l('Balance') }}</th>
                                    <th width="5%">{{ l('Apply') }}</th>
                                    <th class="text-right">{{ l('ApplyAmount') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let data of transactions; let index = index">
                                    <td>{{ index + 1 }}</td>
                                    <td class="col-xs-2">{{ data.transactionNo }}</td>
                                    <td class="col-xs-1">{{ data.referenceNo }}</td>
                                    <td class="col-xs-1"> {{ TransactionType[data.type] || 'N/A' }}</td>
                                    <td class="col-xs-1">{{ data.transactionDate | date: 'yyyy-MMM-dd' }}</td>
                                    <td class="col-xs-1">{{ data.dueDate | date: 'yyyy-MMM-dd' }}</td>
                                    <td class="col-xs-1 text-right">{{ data.amount | priceFormat }}</td>
                                    <td class="col-xs-1 text-right">{{ data.balanceAmount | priceFormat }}</td>

                                    <td class="col-xs-1 text-center">
                                        <input type="checkbox"
                                               [id]="'chkApply_' + index"
                                               [name]="'chkApply_' + index"
                                               [(ngModel)]="data.applied"
                                               [ngClass]="{ edited: data.applied }"
                                               (ngModelChange)="applyAmount(data)" />
                                    </td>

                                    <td class="col-xs-1 text-right">
                                        <input type="number"
                                               maxlength="10"
                                               class="form-control text-end"
                                               name="applyAmount"
                                               [(ngModel)]="data.appliedAmount"
                                               (ngModelChange)="calculateTotalValue()" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <div class="col-lg-12 text-end">
                    <button (click)="goBack()" class="btn btn-danger me-2" [buttonBusy]="saving">
                        <i class="fa fa-close"></i>
                        <span>{{ l('Close') }}</span>
                    </button>
                    <button (click)="save(paymentStatus.Paid)"
                            [hidden]="this.customerPayment.id"
                            class="btn btn-primary blue me-2"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('Save') }}</span>
                    </button>
                    <button [hidden]="customerPayment.status != paymentStatus.UnPaid"
                            (click)="save(paymentStatus.UnPaid)"
                            class="btn btn-primary blue float-right"
                            [buttonBusy]="saving"
                            [busyText]="l('SavingWithThreeDot')">
                        <i class="fa fa-save"></i>
                        <span>{{ l('SaveAsDraft') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
